import React, { useEffect } from 'react';
import styles from './SubmissionSuccess.module.less';
import elementTypeIds from '../../constants/element-types';
import { Images } from '../../style';
import {
  getCustomCampaignSuccessPageData,
  fetchCampaignInfo
} from '../../redux/modules/campaignLandingPage';
import RichText from '../../components/CampaignSuccess/RichTextLandingPageElement';
import ImageElement from '../../components/CampaignLanding/ImageElement';
import { connect } from 'react-redux';

const SubmissionSuccess = ({
  customLandingPage,
  _fetchCampaignInfo,
}) => {
  useEffect(() => {
    if (!customLandingPage) {
      const locationArray = window.location.pathname.split('/');
      const campaignLink = locationArray[locationArray.length - 2];
      _fetchCampaignInfo(campaignLink);
    }
  }, []);

  const imageElement = customLandingPage?.campaignSuccessPageElements?.find((e) => e.elementTypeId === elementTypeIds.IMAGE);
  const richTextElement = customLandingPage?.campaignSuccessPageElements?.find((e) => e.elementTypeId === elementTypeIds.RICH_TEXT);

  if (customLandingPage?.type === 'DESIGN' && customLandingPage?.campaignSuccessPageElements?.length > 0) {
    // Custom success page made of elements
    return (
      <main className={styles.vpCampaignLandingPageContainer}>
        <section>
          <div>
            {imageElement && <ImageElement element={imageElement} />}
            {richTextElement && <RichText element={richTextElement} />}
          </div>
        </section>
      </main>
    );
  } else {
    // Default VideoPeel success page
    return (
      <main className={styles.vpCampaignLandingPageContainer}>
        <section>
          <div>
            <h1 className={styles.vpSubmitSuccessH1}>
              Thank You!
            </h1>
            <img src={Images.vpSwirl} alt="vp-logo" />
          </div>
        </section>
      </main>
    );
  }
}

SubmissionSuccess.propTypes = {};

function mapStateToProps(state) {
  return {
    customLandingPage: getCustomCampaignSuccessPageData(state),
  };
}

const mapDispatchToProps = {
  _fetchCampaignInfo: fetchCampaignInfo,
}

export default connect(mapStateToProps, mapDispatchToProps)(SubmissionSuccess);



// WEBPACK FOOTER //
// ./src/containers/CampaignLandingPage/SubmissionSuccess.jsx